<template>
  <article class="apple-search-entity-card" :class="['is-' + type, { 'has-action': hasMenu, 'is-summary': summary }]">
    <div class="apple-search-entity-art">
      <Cover :id="item.id" :artist="type === 'artist' ? item : null" :type="type === 'artist' ? 'artist' : type" :label="item.name" :image-url="imageUrl" :play-button-size="type === 'artist' ? 22 : 18" />
    </div>
    <div class="apple-search-entity-copy">
      <div class="apple-search-entity-title-row"><button class="apple-search-entity-title" type="button" :title="item.name" @click="open">{{ item.name }}</button><AppleSearchResultMenu v-if="hasMenu" :label="'搜索结果操作：' + item.name" :items="menuItems" @choose="runMenu"/></div>
      <small v-for="(line, index) in detailLines" :key="index" :class="detailClass(index)" :title="line">{{ line }}</small>
    </div>
  </article>
</template>
<script>
import Cover from '../components/Cover.vue';
import { runtime } from '../bridge';
import AppleSearchResultMenu from './AppleSearchResultMenu.vue';
import {artistNavigation} from '../artist-navigation';
import {workspace} from '../workspace';
import './apple-search-entities.scss';
import {releaseYear} from './search-entity-metadata';
const displayName = value => typeof value === 'string' ? value.trim() : typeof value?.name === 'string' ? value.name.trim() : '';
const countValue = value => (typeof value === 'number' || typeof value === 'string' && value.trim() !== '') && Number.isSafeInteger(Number(value)) && Number(value) >= 0 ? Number(value) : null;
export default {
  name: 'AppleSearchEntityCard',
  components: { Cover, AppleSearchResultMenu },
  props: { item: { type: Object, required: true }, type: { type: String, required: true }, canOpen: { type: Boolean, default: true }, summary:Boolean },
  computed: {
    imageUrl() { return this.item.img1v1Url || this.item.picUrl || this.item.coverImgUrl || runtime.cover(); },
    hasMenu(){return this.canOpen&&(this.summary||this.type==='playlist');},
    platformLabel(){return this.item.platform==='tx'?'QQ音乐':this.item.platform==='wy'?'网易云音乐':this.item.platform==='local'?'我的音乐库':'';},
    detailLines() {
      const item = this.item;
      if (this.type === 'album') {
        const artist = displayName(item.artist) || (Array.isArray(item.artists) ? item.artists.map(displayName).filter(Boolean).join(' / ') : '');
        return this.summary?['专辑'+(artist?' · '+artist:'')]:[artist,releaseYear(item)].filter(Boolean);
      }
      if (this.type === 'artist') {
        const fans = countValue(item.fans ?? item.fanCount ?? item.followCount ?? item.followers);
        if(this.summary){const albums=countValue(item.albumSize??item.albumCount);return ['艺术家'+(albums!==null?` · ${albums} 张专辑`:fans!==null?` · ${this.formatCount(fans)} 粉丝`:'')];}
        return [fans !== null ? `${this.formatCount(fans)} 粉丝` : '', this.platformLabel].filter(Boolean);
      }
      if (this.type === 'playlist') {
        const creator = displayName(item.creator?.nickname) || displayName(item.creator?.name) || displayName(item.creator);
        const count = countValue(item.trackCount ?? (Array.isArray(item.trackIds) ? item.trackIds.length : undefined));
        return this.summary?['歌单'+(count!==null?` · ${count} 首`:'')]:[creator, count !== null ? `${count} 首歌曲` : ''].filter(Boolean);
      }
      return [];
    },
    menuItems() { return [{ id: 'open', label: '打开详情' }]; },
  },
  methods: {
    detailClass(index){if(this.summary)return '';if(this.type==='artist')return this.platformLabel&&this.detailLines[index]===this.platformLabel?'is-tertiary':'is-secondary';if(this.type==='album')return this.detailLines[index]===releaseYear(this.item)?'is-tertiary':'is-secondary';if(this.type==='playlist')return countValue(this.item.trackCount??(Array.isArray(this.item.trackIds)?this.item.trackIds.length:undefined))!==null&&index===this.detailLines.length-1?'is-tertiary':'is-secondary';return '';},
    formatCount(value) { const count = Number(value); if (!Number.isFinite(count)) return String(value); if (count >= 10000) return `${(count / 10000).toFixed(count >= 100000 ? 0 : 1)}万`; return String(count); },
    open() {
      if(this.type==='artist'){const target=artistNavigation(this.item,workspace.mode);if(target.route)this.$router.push(target.route).catch(()=>{});else runtime.notify(target.reason,'info');return;}
      const routeName = this.type === 'artist' ? 'artist' : this.type === 'album' ? 'album' : 'playlist';
      this.$router.push({ name: routeName, params: { id: String(this.item.id) } }).catch(() => {});
    },
    runMenu(id) { if (id === 'open') this.open(); },
  },
};
</script>
